import { DrillingMultiAnalysisWidgetWrapper } from '../../drilling-multi-analysis-widget/DrillingMultiAnalysisWidget';
import type { DrillingMultiAnalysisWidgetEntity } from '../../drilling-multi-analysis-widget/DrillingMultiAnalysisWidget.entity';

import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';

export function renderDrillingMultiAnalysisWidget(
  widget: DrillingMultiAnalysisWidgetEntity,
  options: TWidgetRendererOptions,
): TRenderWidget {
  return () => <DrillingMultiAnalysisWidgetWrapper entity={widget} options={options} />;
}
